import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchOrders } from '../api/orderApi';
import { Banknote, CreditCard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const {t}=useTranslation();
 const { clientData, isAuthenticated } = useAuth();
  useEffect(() => {
    if (!clientData || !isAuthenticated){ navigate("/login"); return;}
    loadOrders();
  }, []);

  const loadOrders = async () => {
    try {
      const response = await fetchOrders({client_id:clientData?.client_id});
      setOrders(response);
      setLoading(false);
    } catch (error) {
      setError(t("err.order.fetch"));
      setLoading(false);
    }
  };

  const getPaymentStatusColor = (status) => {
    const statusColors = {
      Pending: "bg-yellow-100 text-yellow-800",
      Failed: "bg-red-100 text-red-800",
      Paid: "bg-green-100 text-green-800"
    };
    return statusColors[status] || "bg-gray-100 text-gray-800";
  };
  const getStatusColor = (status) => {
    const statusColors = {
      pending: "bg-yellow-100 text-yellow-800",
      processing: "bg-blue-100 text-blue-800",
      shipped: "bg-orange-100 text-orange-800",
      delivered: "bg-green-100 text-green-800",
      cancelled: "bg-red-100 text-red-800",
    };
    return statusColors[status] || "bg-gray-100 text-gray-800";
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4">
        <p className="text-red-500">{error}</p>
        <button 
          onClick={loadOrders}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
        >
          {t('TryAgain')}
        </button>
      </div>
    );
  }

  if (!orders || orders?.length===0) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4">
        <p className="text-red-500">{t('Ordernotfound')}</p>
        <button 
          onClick={() => navigate('/')}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
        >
        {t('Chooseproduct')} 
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">{t('MyOrders')}</h1>
      
      <div className="space-y-4 bg-slate-100 p-2 rounded-lg">
        {orders.map((order) => (
          <div 
            key={order.order_id} 
            className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow p-6"
          >
            <div className="flex justify-between items-start">
              <div className="space-y-2">
                <p className="text-sm text-gray-500">
                  {t('OrderID')} #{order.order_id} • {formatDate(order?.order_date)}
                </p>
                <div className="space-y-1">
                  {order?.OrderItems.map((item) => (
                    <div key={item?.order_item_id} className="flex items-center gap-2">
                      <span className="font-medium">{item?.Product?.name}</span>
                      <span className="text-gray-500">
                        × {item?.quantity}
                      </span>
                    </div>
                  ))}
                </div>
                <p className="font-medium">
                  {t('Total')}: {order.Branch.currency} {order?.total_amount.toFixed(2)}
                </p>
              </div>
              
              <div className="flex flex-col items-end gap-3">
              <div className="flex  items-end gap-3">   <span className={`px-3 py-1 rounded-full text-sm ${getStatusColor(order.payments[0]?.payment_status)}`}>
               { order.status}
                </span></div>
              <div className="flex  items-end gap-3"> {order.payments[0]?.payment_method !=="credit_card"? <Banknote />: <CreditCard />}   <span className={`px-3 py-1 rounded-full text-sm ${getPaymentStatusColor(order.payments[0]?.payment_status)}`}>
               {order.payments[0]?.payment_status || "Not Defined"}
                </span></div>
                
                <div className="flex gap-2">
                  {(order.payments[0]?.payment_status === "Failed" || order.payments[0]?.payment_status === "Pending") && (
                    <button 
                      onClick={() => navigate(`/orders/${order.order_id}/pay`, { state: { order } })}
                      className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                    >
                       {order.payments[0]?.payment_method ==="cash_delivery" ? t("paynow"):t("RetryPayment")}
                    </button>
                  )}
                     <button 
                    onClick={() =>    navigate(`/orderdetails`, { state: { order } })}
                    className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 transition-colors"
                  >
                    {t('ViewDetails')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyOrders;


